<script setup lang="ts">
import { BatteryChargingIcon, LeafIcon, ShieldCheckIcon, VolumeXIcon } from 'lucide-vue-next';
import type { Component } from 'vue';

type Feature = {
  id: string;
  icon: Component;
  title: string;
  description: string;
};

const features: Feature[] = [
  {
    id: 'eco',
    icon: LeafIcon,
    title: '100% Экологично',
    description: 'Никаких выхлопных газов и вреда для вашего сада.',
  },
  {
    id: 'quiet',
    icon: VolumeXIcon,
    title: 'Тихая работа',
    description: 'Работайте в любое время, не беспокоя соседей.',
  },
  {
    id: 'battery',
    icon: BatteryChargingIcon,
    title: 'Единая АКБ',
    description: 'Один аккумулятор для всех инструментов одной линейки.',
  },
  {
    id: 'warranty',
    icon: ShieldCheckIcon,
    title: '3 года гарантии',
    description: 'Уверенность в качестве каждого механизма.',
  },
];
</script>

<template>
  <section id="features" class="bg-white">
    <div class="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <ul class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4" aria-label="Основные преимущества Greenworks">
        <li
          v-for="(feature, index) in features"
          :key="feature.id"
          v-motion
          :initial="{ y: 40, opacity: 0 }"
          :enter="{
            y: 0,
            opacity: 1,
            transition: { duration: 600, delay: index * 130, ease: 'easeOut' },
          }"
          class="group text-center"
        >
          <div
            class="mx-auto mb-4 flex size-16 items-center justify-center rounded-2xl bg-green-50 transition-all duration-200 group-hover:bg-green-100 group-hover:shadow-md"
          >
            <component :is="feature.icon" class="size-8 text-green-600" aria-hidden="true" />
          </div>
          <h3 class="mb-2 text-base font-semibold text-gray-900 sm:text-lg">
            {{ feature.title }}
          </h3>
          <p class="text-sm leading-relaxed text-gray-600">
            {{ feature.description }}
          </p>
        </li>
      </ul>
    </div>
  </section>
</template>
